module.exports = __webpack_public_path__ + "static/img/3_2.620fd5cb.jpg";